export default {
  state: {
    activePoi: null,
    activeVenue: null,
    activeTravel: null,
    directionMethod: 'driving',
    mapLoad: false,
    masterplanConfig: null,
    poi: null,
    routeInfo: null,
    category: null,
  },
  getters: {
    getTime: state => {

    },
    getPoi: state => {
      return state.poi;
    }
  },
  mutations: {
    setActivePoi(state, payload) {
      state.activePoi = payload
    },

    setActiveVenue(state, payload) {
      state.activeVenue = payload
    },

    setActiveTravel(state, payload) {
      state.activeTravel = payload
    },

    setDirectionMethod(state, payload) {
      state.directionMethod = payload
    },

    setMapLoad(state, payload) {
      state.mapLoad = payload
    },

    setMasterplanConfig(state, payload) {
      state.masterplanConfig = payload
    },

    setPoi(state, payload) {
      state.poi = payload
    },

    setRouteInfo(state, payload) {
      state.routeInfo = payload;
    },

    zoomToCategory(state, payload) {
      state.category = payload;
    }
  },
  actions: {}
}



// WEBPACK FOOTER //
// ./src/store/amenity.js